var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading && _vm.isAuthenticated)?_c('section',{staticClass:"ine-form"},[_c('Background'),_c('UpdatePasswordForm',{attrs:{"isLoading":_vm.isLoading},on:{"submit-form":_vm.submitForm}})],1):_c('section',[_c('LoadingSpinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }